module.exports = __webpack_public_path__ + "static/media/bg.df85eff4.png";